import React from 'react';

export default function SingleSelectBox({
  options,
  error,
  handleSelectedData,
  disabled,
  value,
  style
}) {
  return (
    <>
      <select
        {...(style ? { style } : {})}
        className="form-control"
        value={value}
        disabled={disabled ? disabled : false}
        onChange={(e) => {
          handleSelectedData(e.target.value);
        }}
      >
        {options?.map((val, i) => {
          return (
            <option value={val.value} key={i} className={val.value === '' ? 'd-none' : ''}>
              {val.label}
            </option>
          );
        })}
      </select>
      <small className="text-danger">{error}</small>
    </>
  );
}
